import { z } from 'zod';

export const $CandidateEconomicActivity = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
});
